import { handleError } from 'utilities/utilities';
import { getApiHost } from '../host-by-env';
import { FirmUnderwritersResponse, MarketplaceProduct, MarketplaceProductStatus } from './types';

export async function getMarketPlaceProducts(
  firmId: string | undefined,
  token: string,
  underwriterCode?: string,
): Promise<MarketplaceProduct[]> {
  const url = `${getApiHost()}marketplace/products/${firmId}${
    underwriterCode ? `?underwriterCode=${encodeURIComponent(underwriterCode)}` : ''
  }`;
  const response = await fetch(url, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  return json.result;
}

export async function getFirmUnderwriters(
  firmId: string | undefined,
  token: string,
): Promise<FirmUnderwritersResponse> {
  const url = `${getApiHost()}firms/${firmId}/underwriters`;
  const response = await fetch(url, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  return json.result;
}

export async function saveFirmUnderwriters(
  firmId: string | undefined,
  underwriterCodes: string[],
  token: string,
): Promise<void> {
  const url = `${getApiHost()}firms/${firmId}/underwriters`;
  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify({ underwriters: underwriterCodes }),
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  return json.result;
}

export async function toggleMarketPlaceProducts(
  productStatus: MarketplaceProductStatus,
  token: string,
): Promise<MarketplaceProductStatus> {
  const url = `${getApiHost()}marketplace/product/status`;
  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify({
      ...productStatus,
    }),
    headers: { Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  return json.result;
}
